import * as React from "react";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { useLeadTimeOverrideApi } from "src/modules/lead-time-override/api/lead-time-override.api";
import LeadTimeOverrideForm from "src/modules/lead-time-override/components/LeadTimeOverridesForm";

/**
 * Create Or Edit Lead Time Overrides page
 *
 */
const CreateEditLeadTimeOverridePage: React.ReactFCWithChildren<PageProps<unknown, {leadTimeOverrideId?: string;}>> = props => {
  const leadTimeOverrideId = props.match && props.match.params.leadTimeOverrideId ? parseInt(props.match.params.leadTimeOverrideId, 10) : null;
  const [ leadTimeOverridesResponse, getLeadTimeOverride ] = useLeadTimeOverrideApi("GET_LEAD_TIME_OVERRIDE");

  React.useEffect(() => {
    if (leadTimeOverrideId) {
      getLeadTimeOverride(leadTimeOverrideId);
    }
  }, [ getLeadTimeOverride, leadTimeOverrideId ]);

  return (
    <Layout
      {...props}
      title="LeadTimeOverrides"
    >
      <MainContentWrapper fill>
        {(leadTimeOverridesResponse.data || !leadTimeOverrideId) &&
          <LeadTimeOverrideForm initialLeadTimeOverride={leadTimeOverridesResponse.data || null} />}
      </MainContentWrapper>
    </Layout>
  );
};

export default CreateEditLeadTimeOverridePage;
